import { CMKManager, getCmkInstance, waitInit } from '@/utils/cmk';
import { IKeyProvider } from '../shared/keyProvider';

/**
 * 主线程版 `IKeyProvider`：直接调用本进程内的 CMK manager，
 * 与 SW 端通过 `messageClient` 反向通信形成对偶实现，
 * 让 `decryptor` / `headerBuilder` 在两端共用同一份逻辑。
 */
export const mainKeyProvider: IKeyProvider = {

    async getKeyBase64({ kdf, iterations, devicePublicKey, keySeed, cmkId }) {

        await waitInit();
        const cmkInstance = await getCmkInstance( cmkId );
        if ( cmkInstance.isErr()) {

            throw cmkInstance.error;

        }
        return CMKManager.getHash(
            kdf,
            iterations,
            cmkInstance.value.gen_shared_key( devicePublicKey ),
            keySeed
        );

    },

    async getSalt({ devicePublicKey, cmkId }) {

        await waitInit();
        const cmkInstance = await getCmkInstance( cmkId );
        if ( cmkInstance.isErr()) {

            throw cmkInstance.error;

        }
        return cmkInstance.value.gen_shared_key( devicePublicKey );

    }

};
